module.exports = __webpack_public_path__ + "static/media/EPS1.cfaffc21.jpg";